import React, { useEffect, useState } from "react";
import * as XLSX from 'xlsx';
import {
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import { FormattedMessage, useIntl } from 'react-intl';
import jzip from 'xlsx/dist/jszip';
import 'xlsx/dist/xlsx.full.min.js';
import SortAsc from "../../assets/images/llantas/table/sort-asc.svg";
import SortDesc from "../../assets/images/llantas/table/sort-desc.svg";
import Sort from "../../assets/images/llantas/table/sort.svg";
import Security from '../../commons/security/Security.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import DiponibilidadGridFilters from './DisponibilidadGridFilters.jsx';
import DisponibilidadGridRow from './DisponibilidadGridRow.jsx';
import { ID_OCIOSIDAD } from '../../commons/constants/tipoMotivos.js';
import Timezone from "../../commons/timezone/Timezone.js";
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import moment from 'moment';
import DisponibilidadGridExport from './DisponibilidadGridExport';
import DisponibilidadGridImport from "./DisponibilidadGridImport.jsx";
import DisponibilidadImportarReporte from "./DisponibilidadImportarReporte.jsx";
import swal from 'sweetalert';

window.JSZip = jzip;

const PAGINATION_INIT ={
page: 0,
count: 0,
perPage: 10,
}

const FILTER_QUERY_INIT = {
  dominio: (ConfigBusiness.get('servicios.enableMultiSearch') == 'true') ? [] : "",
  motivo: "",
  base: "",
  region: "",
  subRegion: "",
  modelo: "",
  tipo: "",
  centroCosto: "",
  fechaHoraInicioOciosidad: "",
  horasOciosidad: "",
  transportadora: [],
  esReserva: "",
  fechaRetornoDesde: "",
  fechaRetornoHasta: ""
}

const SORT_QUERY_INIT = {
  dominio: "",
  motivo : "",
  base: "",
  region: "",
  subRegion: "",
  modelo: "",
  tipo: "",
  centroCosto: "",
  fechaHoraInicioOciosidad: "",
  horasOciosidad: "",
  transportadora: "",
  rentadora: "",
  fechaRetorno: ""
}

const getStorage = () =>{
let storage = JSON.parse(window.localStorage.getItem('DisponibilidadGridFilter'))
if(storage && storage.activo){
 return true
}
else{
  return false
}
}

const DisponibilidadGrid = (props) => {
  const intl = useIntl()
  const [modalExport, setmodalExport] = useState(false);
  const [modalImport, setmodalImport] = useState(false);
  const [modalImportReport, setModalImportReport] = useState(false);
  const [importReportData, setImportReportData] = useState(null);
  const [importSuccessMsg, setImportSuccessMsg] = useState("");

  const [loading, setLoading] = useState(false)
  const [redirectTo, setRedirectTo] = useState(null)
  const [searchActive, setSearchActive] = useState(false)
  const [pagination, setPagination] = useState(JSON.parse(JSON.stringify(PAGINATION_INIT)))
  const [paginationCount, setPaginationCount] = useState(0);
  const [persisteFiltros, setPersisteFiltros] = useState(getStorage())
  const [filterResetInputs, setFilterResetInputs] = useState(false)
  const [filterQuery, setFilterQuery] = useState(null)
  const [sortQuery, setSortQuery] = useState(JSON.parse(JSON.stringify(SORT_QUERY_INIT)))
  const [dropdownActive, setDropdownActive] = useState(false);
  const [moviles, setMoviles] = useState([]);
  const [alertsClicked, setAlertsClicked] = useState([]);
  const [comboMotivos, setComboMotivos] = useState([]);
  const [columnsEnabled, setColumnsEnabled] = useState({
    transportadora: false,
    rentadora: false,
    reserva: false
  })
  const [reservaHabilitado, setReservaHabilitado] = useState(ConfigBusiness.get('moviles.movil_reserva.habilitado') === 'true');

  const handleModalExportOpen = () => {
    setmodalExport(true);
  };

  const handleModalExportClose = () => {
    setmodalExport(false);
  };

  const handleExport = (selectedColumns) => {
    const dataToExport = moviles.map((item) => {
      const row = {};
      Object.keys(selectedColumns).forEach((column) => {
        if (selectedColumns[column]) {
          row[column] = item[column];
        }
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Disponibilidad');
    XLSX.writeFile(workbook, 'Disponibilidad.xlsx');
  };

  const handleModalImportMedidorOpen = () => {
    setmodalImport(true);
  }

  // Callback tipo resetModal, igual que Combustibles
  const handleImportCloseModal = (message, result, error) => {
    setmodalImport(false);
    // Si hay error y es de sesión
    if (error && error.codigo === 4010) {
      swal(intl.formatMessage({ id: 'disponibilidadGrid.alert.sesion_expiro', defaultMessage: 'La sesión expiró' }), intl.formatMessage({ id: 'disponibilidadGrid.alert.ingrese_nuevamente', defaultMessage: 'Por favor, ingrese nuevamente.' }), "error").then(()=>{
        window.location.reload();
      });
    } else if (error && (error.tipo === "filetype" || error.tipo === "error")) {
      // Error de tipo de archivo no soportado: mostrar modal tipo swal (igual que éxito, pero con icono error)
      swal(
        intl.formatMessage({
          id: 'disponibilidadImportar.errors.tipo_archivo_no_soportado',
          defaultMessage: 'Error al importar el archivo. El tipo de archivo no es soportado.'
        }),
        '',
        'error'
      );
    } else if (error && error.errores && Array.isArray(error.errores) && error.errores.length > 0) {
      // Errores de importación (reporte)
      setImportReportData(error.errores.map(e => (typeof e === 'string' ? { fila: '', errores: [e] } : e)));
      setModalImportReport(true);
    } else if (message && (!error || !error.errores)) {
      // Éxito total
      swal(message, '', 'success');
    } else if (message && error) {
      // Otro error
      swal(message, '', 'error');
    }
  };

  const handleImportReportClose = () => {
    setModalImportReport(false);
    setImportReportData(null);
  };

  useEffect(() => {
    setLoading(true)
    if (Security.hasPermission("DISPONIBILIDAD_LISTAR")) {
      filterQuery && init()
    } else {
      setRedirectTo("/error")
    }
    return () => { }
  }, [pagination, filterQuery, sortQuery])

  const init = () => {
    const comboMotivosReq = Utils.getData(`/motivos/simple-search?tipo_motivo=${ID_OCIOSIDAD}`);
    const disponibilidadGridReq = Utils.getData(`/disponibilidad/newGrid${getQuery()}`);
    Promise.all([comboMotivosReq, disponibilidadGridReq])
      .then(([comboMotivos, disponibilidadGrid]) => {
        setComboMotivos(comboMotivos);

        const movilesConHorasOciosidad = disponibilidadGrid.moviles.map((movil) => {
          const fechaInicio = moment(movil.fechaHoraInicioOciosidad);
          const fechaFin = movil.fechaHoraFinOciosidad ? moment(movil.fechaHoraFinOciosidad) : moment();
          const diffInMinutes = fechaFin.diff(fechaInicio, 'minutes');
          const hours = Math.floor(diffInMinutes / 60);
          const minutes = diffInMinutes % 60;
          const horasOciosidad = `${hours}h ${minutes}m`;

          return {
              ...movil,
              horasOciosidad,
          };
      });

        setMoviles(movilesConHorasOciosidad);
        setPaginationCount(disponibilidadGrid.pagination.count);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false)
      })
    configColumns();
  };

  const configColumns = () => {
    let aux = { ...columnsEnabled }
    aux.transportadora = ConfigBusiness.get("moviles.transportadora.grilla") === 'true';
    aux.rentadora = ConfigBusiness.get("frontend.rentadora.grilla") === 'true';
    aux.esReservaEnabled = ConfigBusiness.get('moviles.reserva.grilla') === 'true';
    setColumnsEnabled(aux)
  }

  const getQuery = () => {

    let myQuery = "?page=" + pagination.page
    myQuery += "&perPage=" + pagination.perPage

    myQuery += "&dominio=" + filterQuery.dominio;
    myQuery += "&motivo=" + filterQuery.motivo;
    myQuery += "&modelo=" + filterQuery.modelo;
    myQuery += "&tipo=" + filterQuery.tipo;
    myQuery += "&region=" + filterQuery.region;
    myQuery += "&subRegion=" + filterQuery.subRegion;
    myQuery += "&base=" + filterQuery.base;
    myQuery += "&centroCosto=" + filterQuery.centroCosto;
    myQuery += "&transportadora=" + filterQuery.transportadora;
    myQuery += "&esReserva=" + filterQuery.esReserva;
    myQuery += "&fechaRetornoDesde=" + filterQuery.fechaRetornoDesde;
    myQuery += "&fechaRetornoHasta=" + filterQuery.fechaRetornoHasta;

    myQuery += "&dominioSort=" + sortQuery.dominio;
    myQuery += "&motivoSort=" + sortQuery.motivo;
    myQuery += "&modeloSort=" + sortQuery.modelo;
    myQuery += "&tipoSort=" + sortQuery.tipo;
    myQuery += "&baseSort=" + sortQuery.base;
    myQuery += "&regionSort=" + sortQuery.region;
    myQuery += "&subRegionSort=" + sortQuery.subRegion;
    myQuery += "&centroCostoSort=" + sortQuery.centroCosto;
    myQuery += "&fechaHoraInicioOciosidadSort=" + sortQuery.fechaHoraInicioOciosidad;
    myQuery += "&transportadoraSort=" + sortQuery.transportadora;
    myQuery += "&rentadoraSort=" + sortQuery.rentadora;
    myQuery += "&fechaRetornoSort=" + sortQuery.fechaRetorno;

    return myQuery;
  }

  const handleChangePage = (event, newPage) => {
    setPagination({ ...pagination, page: newPage });
  }

  const handleChangeRowsPerPage = (event) => {
    setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 });
  }

  const requestSort = (key) => {
    let query = { ...sortQuery }
    let aux = sortQuery[key];
    query["motivo"] = "";
    query["dominio"] = "";
    query["modelo"] = "";
    query["tipo"] = "";
    query["region"] = "";
    query["subRegion"] = "";
    query["base"] = "";
    query["centroCosto"] = "";
    query["fechaHoraInicioOciosidad"] = "";
    query["horasOciosidad"] = "";
    query["transportadora"] = "";
    query["fechaRetorno"] = "";

    pagination.page = 0;

    if (!aux) query[key] = "asc";
    else if (aux === "desc") query[key] = "asc";
    else query[key] = "desc";
    setSortQuery(query);
  };

  const handleFilterReset = () => {
    setPagination(JSON.parse(JSON.stringify(PAGINATION_INIT)));
    setFilterQuery(JSON.parse(JSON.stringify(FILTER_QUERY_INIT)));
    setSortQuery(JSON.parse(JSON.stringify(SORT_QUERY_INIT)));
    setDropdownActive(false);
    setSearchActive(false);
    setAlertsClicked([])
    setPersisteFiltros(false)
    setFilterResetInputs(true)
  }

  const handleAlertClick = (filter) => {
    let copyClicked = alertsClicked;
    let reset = false;
    if (alertsClicked[filter]) {
      reset = true;
      copyClicked[filter] = !alertsClicked[filter];
    } else {
      for (let alarm in alertsClicked) {
        copyClicked[alarm] = false;
      }
      copyClicked[filter] = true;
    }

    setAlertsClicked(copyClicked)

    let query = { ...filterQuery };
    query['filtroKpi'] = reset ? "" : filter;
    setFilterQuery(query);
  }


  /**
   * Responde siempre que el filtro cambie
   *  - acutaliza paginado en pagina 0
   *  - otros
   */
  const handleFilterChange = () => {
    setPagination(prevState => ({ ...prevState, page: 0 }));
  }

  const handleActualizarMotivo = (motivoId, movilActualizadoId) => {
    const listaMovilesActualizada = moviles.map(movil => {
      if (movil.id === movilActualizadoId) {
        return {
          ...movil,
          motivo_id: motivoId,
          fecha_actualizacion_motivo: Timezone.getDateForClient('now', null, 'YYYY-MM-DD HH:mm'),
          usuarioModificacionMotivo: getNombreUsuario()
        }
      } else {
        return movil;
      }
    });

    setMoviles(listaMovilesActualizada);
  }

  const getNombreUsuario = () => {
    const persona = JSON.parse(localStorage.getItem("persona"));
    return persona ? `${persona.nombre} ${persona.apellido}` : '';
  }

  return (
    <>
      <DisponibilidadGridExport
        open={modalExport}
        handleClose={handleModalExportClose}
        handleExport={handleExport}
				queryFilters={filterQuery}
        reservaHabilitado={reservaHabilitado}
      />

      <DisponibilidadGridImport
        open={modalImport}
        handleClose={() => setmodalImport(false)}
        callbackClose={handleImportCloseModal}
        handleFilterReset={handleFilterReset}
      />

      {/* Modal de reporte de importación y error de tipo de archivo */}
      {modalImportReport && (
        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: 'block' }}>
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className={`modal-header ${modalImportReport === 'filetype' ? 'bg-danger' : 'bg-fleet'}`}>
                <h4 className="modal-title text-white" id="importReportLabel">
                  {modalImportReport === 'filetype' ? (
                    <>
                      <span style={{ marginRight: 8 }}>
                        <i className="fa fa-times-circle" style={{ color: '#ff394f', fontSize: '1.5em' }}></i>
                      </span>
                      <FormattedMessage id="disponibilidadImportar.errors.error_al_importar" defaultMessage="Error al importar el archivo" />
                    </>
                  ) : (
                    <FormattedMessage id="disponibilidadImportar.success.reporte_de_la_importacion" defaultMessage="Reporte de la Importación" />
                  )}
                </h4>
                <button type="button" className="close" onClick={handleImportReportClose} aria-label="Close"><span aria-hidden="true">&times;</span></button>
              </div>
              <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                <DisponibilidadImportarReporte data={importReportData} callbackReportClose={handleImportReportClose} />
                {modalImportReport === 'filetype' && (
                  <div className="alert alert-danger mt-3">
                    {importReportData && importReportData[0] && importReportData[0].errores[0]}
                  </div>
                )}
              </div>
              <div className="modal-footer modal-grey">
                <button type="button" className="btn btn-default btn-fleet" onClick={handleImportReportClose}>Ok</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="card">
        <div className="card-content collpase show">
          <div className="card-body card-dashboard">
            <div className="container-fluid mb-1">
              <div className="row dt-icons" style={{ width: '100%' }}>
                <div className="col">
                  <div
                    className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                    style={{ height: 52 }}
                    onClick={() => setDropdownActive(!dropdownActive)}
                  >
                    {dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
                  </div>
                </div>
                <div className="col">
                  {searchActive && (
                    <div className="btn-dt-main round-icon">
                      <div
                        className="text-center"
                        style={{
                          height: '25px',
                          borderRadius: '3px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          paddingLeft: '8px',
                          backgroundColor: '#5AAC43',
                          color: 'white',
                        }}
                      >
                        <div
                          className="text-center"
                          style={{
                            width: '100%',
                            fontSize: '12px',
                            fontWeight: '500',
                          }}
                        >
                          {moviles.length} de {paginationCount} resultados de busqueda
                        </div>
                        <div className="resultados-busqueda-notif">
                          <i
                            className="las la-times la-xs cursor-pointer"
                            onClick={() => handleFilterReset()}
                          ></i>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="row">
                  <div className="col">
                      <ButtonsTableTop
                        intl={intl}
                        handleModalExportOpen={handleModalExportOpen}
                      />
                  </div>
                  {Security.hasPermission("IMPORTAR_RUTAS_HISTORICAS") &&
                    <div className="col">
                      <ButtonsTableTopImport
                        intl={intl}
                        handleModalImportMedidorOpen={handleModalImportMedidorOpen}
                      />
                    </div>
                  }
                </div>
                
              </div>
            </div>

            {/* <MovilesGridFiltros/> */}
            <DiponibilidadGridFilters
              dropdownActive={dropdownActive}
              setDropdownActive={setDropdownActive}
              persisteFiltros={persisteFiltros}
              setPersisteFiltros={setPersisteFiltros}
              filterResetInputs={filterResetInputs}
              setFilterResetInputs={setFilterResetInputs}
              filterQuery={filterQuery}
              setFilterQuery={setFilterQuery}
              searchActive={searchActive}
              setSearchActive={setSearchActive}
              loading={loading}
              pagination={pagination}
              kpi={props.location.state}
              handleAlertClick={handleAlertClick}
              handleFilterChange={handleFilterChange}
              columnsEnabled={columnsEnabled}
              reservaHabilitado={reservaHabilitado}
            />
            <TableContainer>
              <Table aria-label="clases table" className="table-hover">
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left" onClick={() => requestSort("dominio")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_dominio.label" defaultMessage="Dominio" />
                      <img className="ml-1"
                        src={sortQuery.dominio === "" ? Sort : sortQuery.dominio === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell></StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("motivo")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_motivo.label" defaultMessage="Motivo" />
                      <img className="ml-1"
                        src={sortQuery.motivo === "" ? Sort : sortQuery.motivo === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("fechaRetorno")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_fecha_retorno.label" defaultMessage="Fecha de Retorno" />
                      <img className="ml-1"
                        src={sortQuery.fechaRetorno === "" ? Sort : sortQuery.fechaRetorno === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("modelo")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_modelo.label" defaultMessage="Modelo" />
                      <img className="ml-1"
                        src={sortQuery.modelo === "" ? Sort : sortQuery.modelo === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("tipo")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_tipo.label" defaultMessage="Tipo" />
                      <img className="ml-1"
                        src={sortQuery.tipo === "" ? Sort : sortQuery.tipo === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("base")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_base.label" defaultMessage="Base" />
                      <img className="ml-1"
                        src={sortQuery.base === "" ? Sort : sortQuery.base === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("subRegion")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_subRegion.label" defaultMessage="Sub.Región" />
                      <img className="ml-1"
                        src={sortQuery.subRegion === "" ? Sort : sortQuery.subRegion === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("region")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_region.label" defaultMessage="Región" />
                      <img className="ml-1"
                        src={sortQuery.region === "" ? Sort : sortQuery.region === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>

                    <StyledTableCell show={columnsEnabled.transportadora} align="left" onClick={() => requestSort("transportadora")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_transportadora.label" defaultMessage="Transportadora" />
                      <img className="ml-1"
                        src={sortQuery.transportadora === "" ? Sort : sortQuery.transportadora === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell show={columnsEnabled.rentadora} align="left" onClick={() => requestSort("rentadora")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_rentadora.label" defaultMessage="Rentadora" />
                      <img className="ml-1"
                        src={sortQuery.rentadora === "" ? Sort : sortQuery.rentadora === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("centroCosto")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_centro_costos.label" defaultMessage="Centro de Costos" />
                      <img className="ml-1"
                        src={sortQuery.centroCosto === "" ? Sort : sortQuery.centroCosto === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell show={columnsEnabled.esReservaEnabled} align="left" onClick={() => requestSort("esReserva")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_es_reserva.label" defaultMessage="Es Reserva" />
                    </StyledTableCell>
                    <StyledTableCell align="left" onClick={() => requestSort("fechaHoraInicioOciosidad")} style={{ cursor: "pointer" }}>
                      <FormattedMessage id="disponibilidadGrid.rennder.column_fecha_inicio_ociosidad.label" defaultMessage="Fecha y hora inicio de ociosidad" />
                      <img className="ml-1"
                        src={sortQuery.fechaHoraInicioOciosidad === "" ? Sort : sortQuery.fechaHoraInicioOciosidad === "asc" ? SortAsc : SortDesc}
                        alt={"/"}
                        style={{ height: "12px", width: "22px" }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="left">
                      <FormattedMessage id="disponibilidadGrid.rennder.column_horas_ociosidad.label" defaultMessage="Horas de ociosidad" />
                    </StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loading && (
                    <TableRow>
                      <StyledTableCell colSpan={14} align="center">
                        <CircularProgress />
                      </StyledTableCell>
                    </TableRow>
                  )}
                  {!loading &&
                    (moviles.length > 0 ?
                      moviles.map((movil) => (
                        <DisponibilidadGridRow
                          key={'disponibilidadGridRow_' + movil.id}
                          baseUrl={props.match.url}
                          movil={movil}
                          loading={loading}
                          comboMotivos={comboMotivos}
                          onActualizarMotivo={handleActualizarMotivo}
                          columnsEnabled={columnsEnabled}
                        />
                      ))
                      :
                      <TableRow>
                        <StyledTableCell colSpan={14} align="center">
                          <FormattedMessage id="disponibilidadGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
                        </StyledTableCell>
                      </TableRow>
                    )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={paginationCount}
              rowsPerPage={pagination.perPage}
              page={pagination.page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Mostrar"
              labelDisplayedRows={({ from, to, count }) => `Mostrando ${from} a ${to} de ${count}`}
            />
          </div>
        </div>
      </div>
    </>
  )
}

const ButtonsTableTop = (props) => {
  const intl = props.intl

  return (
    <div className="dt-buttons btn-group">
      <div className="dropdown">
        <StyledTooltip
          title={intl.formatMessage({
            id: 'movilesGrid.tools_export.title_exportar_a_excel',
            defaultMessage: 'Exportar a Excel',
          })}
          arrow
          placement="top"
        >
          <button className="btn buttons-collection" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span>
              <i className="ft-upload"></i>
            </span>
          </button>
        </StyledTooltip>
        <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
          <button style={{ fontSize: '15px' }} onClick={() => props.handleModalExportOpen()} className="btn btn-secondary buttons-collection" type="button">
            <span>
              <FormattedMessage id="disponibilidadGrid.render.export_modal.header_exportar_disponibilidad" defaultMessage="Exportar Disponibilidad" />
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

const ButtonsTableTopImport = (props) => {
  const intl = props.intl

  return (
    <div className="dt-buttons btn-group">
      <div className="dropdown">
        <StyledTooltip
          title={intl.formatMessage({
            id: 'movilesGrid.tools_import.title_importar_excel',
            defaultMessage: 'Importar Excel',
          })}
          arrow
          placement="top"
        >
          <button className="btn buttons-collection" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span>
              <i className="ft-download"></i>
            </span>
          </button>
        </StyledTooltip>
        <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
          <button style={{ fontSize: '15px' }} onClick={() => props.handleModalImportMedidorOpen()} className="btn btn-secondary buttons-collection" type="button">
            <span>
              <FormattedMessage id="disponibilidadGrid.render.import_modal.header_importar_disponibilidad" defaultMessage="Importar Disponibilidad" />
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default DisponibilidadGrid